/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type EventSummary_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly primaryOrgCalendar: string;
    readonly nextDefragTime: {
        readonly millis?: unknown | null | undefined;
    } | null;
    readonly shadowCalendarSettingsErrorable: {
        readonly __typename: "ShadowCalendarSettings";
        readonly focusTimeSyncAll: boolean;
        readonly focusTimeIdealMinutesPerWeek: number;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly personsByCalendarIdsErrorable: {
        readonly __typename: "PersonList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly emails: ReadonlyArray<string>;
            readonly primaryEmail: string;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly isYou: boolean;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly userTeams: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly teamId: string;
            readonly teamCalendarId: string | null;
            readonly teamName: string;
            readonly createdBy: {
                readonly value: string | null;
            };
            readonly teamMembers: ReadonlyArray<{
                readonly person: {
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                };
            }>;
            readonly invitedMembers: ReadonlyArray<{
                readonly person: {
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                };
            }>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly userGoals: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string;
                readonly options: {
                    readonly specificOptions: {
                        readonly maxMinutesPerBlock?: number | undefined;
                        readonly minimumDuration?: number | null | undefined;
                        readonly idealDuration?: number | null | undefined;
                        readonly minTimeSlot?: TimeSlot | null | undefined;
                        readonly maxTimeSlot?: TimeSlot | null | undefined;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryAutopilot_org" | "EventSummaryColorCategory_org" | "EventSummaryRecurrence_org" | "EventSummaryTime_org" | "EventTimeAndRecurrence_org" | "AutopilotFormSaveOnEdit_org">;
    readonly " $refType": "EventSummary_org";
};
export type EventSummary_org$data = EventSummary_org;
export type EventSummary_org$key = {
    readonly " $data"?: EventSummary_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummary_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "calendarIds",
            "variableName": "calendarIds"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v7 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                (v6 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AvatarPerson_orgPerson"
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": [],
                "kind": "LocalArgument",
                "name": "calendarIds"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventSummary_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextDefragTime",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "millis",
                                "storageKey": null
                            }
                        ],
                        "type": "DefragTime",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "shadowCalendarSettingsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "focusTimeSyncAll",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "focusTimeIdealMinutesPerWeek",
                                "storageKey": null
                            }
                        ],
                        "type": "ShadowCalendarSettings",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            },
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": (v3 /*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "personsByCalendarIdsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryEmail",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": [
                                            (v4 /*: any*/),
                                            (v5 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "externalImageUrl",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    (v6 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "PersonList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamCalendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "createdBy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "teamMembers",
                                        "plural": true,
                                        "selections": (v7 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "invitedMembers",
                                        "plural": true,
                                        "selections": (v7 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                    }
                ],
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "userGoals",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "GoalOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "specificOptions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "maxMinutesPerBlock",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "GoalWithinWeekOptions",
                                                        "abstractKey": null
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "minimumDuration",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "idealDuration",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "minTimeSlot",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "maxTimeSlot",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "GoalWithinDayOptions",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "userGoals(first:1000000)"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryAutopilot_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryColorCategory_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryRecurrence_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummaryTime_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventTimeAndRecurrence_org"
            },
            {
                "args": (v3 /*: any*/),
                "kind": "FragmentSpread",
                "name": "AutopilotFormSaveOnEdit_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'd038f76df535f45f288f10dbf5d19eaa';
export default node;
